import {
  UPDATE_TASK_REQUEST,
  UPDATE_TASK_SUCCESS,
  UPDATE_TASK_FAILURE
} from '../../../actions/api/task';
import {
  GET_RUN_REQUEST,
  GET_RUN_SUCCESS,
  GET_RUN_FAILURE
} from '../../../actions/api/run';
import { ADD_FILE_REQUEST, ADD_FILE_SUCCESS } from '../../../actions/api/file';
import {
  TASK_ITEM_INITIALIZE,
  TASK_ITEM_SELECT_UPDATE_OPTION,
  TASK_ITEM_FIELD_UPDATE
} from '../../../actions/page/tasks/TaskItem';

export default function TaskDetail(state = { loading: true }, action) {
  switch (action.type) {
    case TASK_ITEM_INITIALIZE:
      const defaults = {
        loading: true,
        uploadingFiles: false,
        error: false,
        errorMessage: '',
        saving: false
      };
      return {
        ...state,
        ...defaults
      };

    case TASK_ITEM_SELECT_UPDATE_OPTION:
      return {
        ...state
      };

    case GET_RUN_REQUEST:
      return {
        ...state,
        error: false,
        errorMessage: '',
        loading: true
      };

    case GET_RUN_SUCCESS:
      return {
        ...state,
        loading: false
      };

    case GET_RUN_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        errorMessage: action.error
      };

    case ADD_FILE_REQUEST:
      return {
        ...state,
        uploadingFiles: true
      };

    case ADD_FILE_SUCCESS:
      return {
        ...state,
        uploadingFiles: false
      };

    case UPDATE_TASK_REQUEST:
      return {
        ...state,
        error: false,
        errorMessage: '',
        saving: true
      };

    case UPDATE_TASK_SUCCESS:
      return {
        ...state,
        saving: false
      };

    case UPDATE_TASK_FAILURE:
      return {
        ...state,
        saving: false,
        error: true,
        errorMessage: action.error
      };

    case TASK_ITEM_FIELD_UPDATE:
      const fields = state.fields || {};
      let updatedField = {};

      // we are saving all field data here in order to
      // know what field is what when saving.
      updatedField[action.field.fieldName] = action.field;

      return {
        ...state,
        fields: {
          ...fields,
          ...updatedField
        }
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./js/reducers/page/tasks/TaskItem.js